import React from 'react';
import { Box, Typography } from '@mui/material';

const Informes: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Informes</Typography>
    </Box>
  );
}

export default Informes;
